<style lang="scss">
  .cartContent {
    .text-center {
      p {
        margin-top: 70px;
        font-size: 34px;
        font-weight: 800;
        text-transform: uppercase;
      }
    }
    .books {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 50px;
      grid-row-gap: 80px;
      p:nth-of-type(2) {
        font-size: 16px;
      }
    }
    @media (min-width: 992px) {
      .books {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }
</style>
<template>
  <div class="cartContent">
    <FrontendNav></FrontendNav>
    <div class="container">
      <h1>Összegzés</h1>
      <p class="orderProgress">
        <span>Rendelés adatok</span> <i></i> <span>Fizetés</span> <i></i> <span class="active">Összegzés</span>
      </p>
      <div class="text-center" style="margin-bottom: 120px">
        <p>Köszönjük, hogy nálunk<br>vásárolt.</p>
        <a href="/" class="btn btn-primary">Vissza a főoldalra</a>
      </div>
      <p style="font-size: 16px; font-weight: 600;">Ezeket látta már?</p>
      <ul class="books">
        <li v-for="book in books" :key="book.id">
          <FrontendBooklink
            :button="false"
            :book="book"
          ></FrontendBooklink>
        </li>
      </ul>
    </div>
    <FrontendFooter></FrontendFooter>
  </div>
</template>

<script>
import FrontendNav from '../partials/nav'
import FrontendFooter from '../partials/footer'
import FrontendBooklink from '../partials/booklink'

export default {
  name: 'OrderSuccess',
  components: {
    FrontendNav,
    FrontendFooter,
    FrontendBooklink
  },
  data: function () {
    return {
      catName: 'Összes',
      catUrl: '',
      activeCat: '/konyvek',
      catOrder: true,
      categories: [],
      books: [],
      fbhKey: 0,
      limit: 4,
      offset: 0,
      isMoreBtn: false,
      order_by: [],
      order: []
    }
  },
  created: function () {
    localStorage.removeItem('cartItems')
    localStorage.removeItem('orderForm')
    localStorage.removeItem('cartSumPrice')
    this.getBooks(this.url + `/books/` + this.limit + `/` + this.offset + `/`)
  },
  mounted: function () {
  },
  computed: {
    url: function () {
      return process.env.API_URL + '/' + process.env.API_ENDPOINT
    }
  },
  methods: {
    getBooks: function (_url, add = false) {
      if (this.order_by !== null) {
        _url += '?order_by=' + this.order_by + '&order=' + this.order
      }
      this.$http
        .get(_url, {
          'headers': {
            'language': this.$store.state.loading.language
          }
        }).then(res => {
          if (res.data.data.length < this.limit) {
            this.isMoreBtn = false
          } else {
            this.isMoreBtn = true
          }
          if (add) {
            for (let item in res.data.data) {
              this.books.push(res.data.data[item])
            }
          } else {
            this.books = res.data.data
          }
        }).catch(res => {
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/frontend/order/success.vue